export const ANALYTICS_EVENTS = {
  // Authentication Events
  AUTH: {
    LOGIN_PAGE_VISIT: 'login_page_visit',
    PHONE_NUMBER_ENTERED: 'phone_number_entered',
    OTP_TRIGGERED: 'otp_triggered',
    OTP_ENTERED: 'otp_entered',
    SIGN_UP: 'sign_up',
    SIGN_IN: 'sign_in',
  },


} as const;

// Type safety for event names
export type AnalyticsEventName = 
  | typeof ANALYTICS_EVENTS.AUTH[keyof typeof ANALYTICS_EVENTS.AUTH]

// Helper function to get all event names
export function getAllEventNames(): string[] {
  const events: string[] = [];
  
  Object.values(ANALYTICS_EVENTS).forEach(category => {
    Object.values(category).forEach(eventName => {
      events.push(eventName);
    });
  });
  
  return events;
}

// Helper function to get events by category
export function getEventsByCategory(category: keyof typeof ANALYTICS_EVENTS): string[] {
  return Object.values(ANALYTICS_EVENTS[category]);
} 